<!--
 * @Author: 云逸 1832583130@qq.com
 * @Date: 2023-04-17 20:27:33
 * @LastEditors: 云逸
 * @LastEditTime: 2024-02-06 20:09:50
 * @FilePath: \tea-admin\src\views\businessManagement\index.vue
 * @Description: 会员管理
 * aa
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <el-form-item label class="form-item-b0">
            <el-button :type="checkBtnCurrent == 1 ? 'primary' : ''" size="small" @click="getList('place', 1)"
              >待审核</el-button
            >
            <el-button :type="checkBtnCurrent == 2 ? 'success' : ''" size="small" @click="getList('place', 2)"
              >已认证</el-button
            >
            <el-button :type="checkBtnCurrent == 3 ? 'warning' : ''" size="small" @click="getList('place', 3)"
              >已退回</el-button
            >
            <el-button :type="checkBtnCurrent == 4 ? 'danger' : ''" size="small" @click="getList('place', 4)"
              >未付款</el-button
            >
          </el-form-item>

          <el-form-item label="手机号码：" class="form-item-b0">
            <el-input v-model="query.search" placeholder="请输入手机号码" size="small" clearable></el-input>
          </el-form-item>

          <el-form-item label="商户：" class="form-item-b0">
            <el-select v-model="query.certificationType">
              <el-option label="全部" :value="null"></el-option>
              <el-option :label="$store.state.user.info.Name === 'user' ? 320 : 680" value="个人"></el-option>
              <el-option :label="$store.state.user.info.Name === 'user' ? 680 : 1680" value="商户"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="过期：" class="form-item-b0">
            <el-select v-model="query.isStoreVip">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="过期" :value="2"></el-option>
              <el-option label="未过期" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="省份：" class="form-item-b0">
            <el-input v-model="query.province" placeholder="请输入省份" size="small" clearable></el-input>
          </el-form-item>-->

          <el-form-item label="省份：" class="form-item-b0">
            <el-select v-model="query.province" clearable @change="handleChange1" filterable style="width: 100%">
              <el-option
                v-for="item in regionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="城市：" class="form-item-b0">
            <el-input v-model="query.city" placeholder="请输入城市" size="small" clearable></el-input>
          </el-form-item>-->

          <el-form-item label="城市：" class="form-item-b0">
            <el-select v-model="query.city" clearable @change="handleChange2" filterable style="width: 100%">
              <el-option
                v-for="item in regionOptions1"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="时间：" class="form-item-b0">
            <el-date-picker
              v-model="beginDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="总条数" class="form-item-b0">
            <span style="font-size: 40px">{{ total }}</span>
          </el-form-item>
        </el-form>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>
          <el-button size="small" @click="init()">重置</el-button>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column prop="Id" label="Id" align="center"> </el-table-column>

      <el-table-column prop="LoginName" label="手机号码" align="center">
        <template slot-scope="scope">
          <div style="cursor: pointer" @click.stop="query.search = scope.row.LoginName">
            {{ scope.row.LoginName.slice(0, 4) + '****' + scope.row.LoginName.slice(8) }}
          </div>
          <template v-if="$store.state.user.info.Name !== 'user'">
            <span v-if="ifOverdue(scope.row.VipTime)" style="color: #f00">VIP已过期</span>
            <span v-else>(VIP {{ scope.row.VipTime | remainingDays }}天)</span>
          </template>
        </template>
      </el-table-column>

      <el-table-column label="省市区" align="center">
        <template slot-scope="scope">{{ scope.row.Province }}-{{ scope.row.City }}-{{ scope.row.Area }}</template>
      </el-table-column>

      <el-table-column prop="StoreName" label="商铺名称" align="center">
        <template slot-scope="scope">
          <template>
            <div>{{ scope.row.StoreName.slice(0, 1) + '****' }}</div>

            <template v-if="$store.state.user.info.Name !== 'user'">
              <div
                v-if="scope.row.StoreVipTime"
                :style="{ color: ifOverdue(scope.row.StoreVipTime) ? '#f00' : '#606266' }"
              >
                ({{ scope.row.StoreVipTime | remainingDays }}天)
              </div>
              <div v-else style="color: #f00">(无)</div>
            </template>
          </template>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="StoreType" label="商铺类型" align="center">
        <template slot-scope="scope">
          <template>
            <span>{{ scope.row.StoreType }}</span>
          </template>
        </template>
      </el-table-column>-->

      <el-table-column prop="StoreAddress" label="具体地址" align="center">
        <template slot-scope="scope">{{ scope.row.StoreAddress.slice(0, 4) + '****' }}</template>
      </el-table-column>

      <!-- <el-table-column prop="Store" label="关注/粉丝" align="center" v-if="$store.state.user.info.Name !== 'user'">
        <template slot-scope="scope">
          <template>
            <div>关注: {{ scope.row.CollectionCount || 0 }}</div>
            <div>粉丝: {{ scope.row.FollowCount || 0 }}</div>
            <div>发布: {{ scope.row.ArticleCount || 0 }}</div>
            <div>留言: {{ scope.row.SupportList.length || 0 }}</div>
          </template>
        </template>
      </el-table-column>

      <el-table-column v-if="checkBtnCurrent !== 4" prop="ParentId" label="上级Id" align="center"></el-table-column>

      <el-table-column v-if="checkBtnCurrent === 4" prop="StoreSubmitTime" label="提交时间" align="center">
        <template slot-scope="scope">{{ new Date(scope.row.SubmitTime) | parseTime }} </template>
      </el-table-column>

      <el-table-column
        prop="StoreAuditTime"
        label="审核时间"
        align="center"
        v-if="checkBtnCurrent !== 4 && $store.state.user.info.Name !== 'user'"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.StoreAuditTime">{{ new Date(scope.row.StoreAuditTime) | parseTime }}</span>
          <span v-else>无</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column prop="StoreVipTime" label="商户会员时间" align="center">
        <template slot-scope="scope" v-if="scope.row.StoreVipTime">
          {{ new Date(scope.row.StoreVipTime) | parseTime }}
        </template>
      </el-table-column>-->

      <!-- <el-table-column
        prop="StoreAuditStatus"
        label="状态"
        align="center"
        v-if="checkBtnCurrent !== 4"
      >
        <template slot-scope="scope">
          <div
            :style="{ color: auditStatus[scope.row.StoreAuditStatus].type }"
            style="font-size: 16px;"
          >{{ auditStatus[scope.row.StoreAuditStatus].text }}</div>
        </template>
      </el-table-column>-->

      <!-- <el-table-column label="发布" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="undercarriage(scope.row.Id)">下 架</el-button>
        </template>
      </el-table-column> -->

      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onEditInfo(scope.row)">审 核</el-button>
          <!-- <div></div>
          <el-button type="warning" size="mini" @click="release(scope.row)" style="margin-top: 10px">发 布</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 商户管理 -->
    <el-dialog
      :visible.sync="editPhoneDialog"
      class="FormDialogBox"
      width="800px"
      title="商户管理"
      top="5vh"
      :close-on-click-modal="false"
      @close="editPhoneCancel()"
    >
      <div class="tabs">
        <el-tabs v-model="activeName" stretch @tab-click="handleClick">
          <el-tab-pane label="商户资料" name="商户资料"></el-tab-pane>
          <el-tab-pane label="发布历史" name="发布历史"></el-tab-pane>
          <el-tab-pane label="商品发布" name="商品发布" v-if="$store.state.user.info.Name !== 'user'"></el-tab-pane>
          <el-tab-pane label="商户产品库" name="商户产品库" v-if="$store.state.user.info.Name !== 'user'"></el-tab-pane>
          <el-tab-pane label="留言" name="留言"></el-tab-pane>
          <el-tab-pane label="关注" name="关注" v-if="$store.state.user.info.Name !== 'user'"></el-tab-pane>
          <el-tab-pane label="粉丝" name="粉丝" v-if="$store.state.user.info.Name !== 'user'"></el-tab-pane>
        </el-tabs>
      </div>

      <template v-if="activeName === '商户资料'">
        <el-form label-width="auto" :model="editForm" :rules="rules" ref="ruleForm">
          <div style="display: flex">
            <el-form-item label="认证套餐">
              <el-radio v-model="editForm.CertificationType" label="个人">
                {{ $store.state.user.info.Name === 'user' ? 320 : 680 }}
              </el-radio>
              <el-radio v-model="editForm.CertificationType" label="商户">
                {{ $store.state.user.info.Name === 'user' ? 680 : 1680 }}
              </el-radio>
            </el-form-item>

            <el-form-item label=" " v-if="$store.state.user.info.Name !== 'user'">
              <span style="margin-left: 10px">认证时间：</span>
              <span v-if="editForm.StoreSubmitTime">{{ new Date(editForm.StoreSubmitTime) | parseTime }}</span>
              <span v-else>暂未认证</span>
            </el-form-item>
          </div>

          <div style="display: flex">
            <el-form-item label="手机号" prop="Phone">
              <el-input v-model="editForm.Phone" placeholder="手机号" disabled></el-input>
            </el-form-item>
            <el-form-item label>
              <template v-if="$store.state.user.info.Name !== 'user'">
                <span v-if="ifOverdue(editForm.VipTime)" style="color: #f00">(VIP已过期)</span>
                <span v-else>(VIP {{ editForm.VipTime | remainingDays }}天)</span>
              </template>

              <template v-if="$store.state.user.info.Name !== 'user'">
                <span v-if="!editForm.StoreVipTime" style="color: #f00; margin-left: 20px">(商户审核中)</span>
                <span v-else-if="ifOverdue(editForm.StoreVipTime)" style="color: #f00; margin-left: 20px"
                  >(商户VIP已过期)</span
                >
                <span v-else style="margin-left: 20px">(商户 {{ editForm.StoreVipTime | remainingDays }}天)</span>
              </template>

              <span style="margin-left: 10px">注册时间：</span>
              <span>{{ new Date(editForm.CreateTime) | parseTime }}</span>
            </el-form-item>
          </div>

          <div style="display: flex">
            <el-form-item label="商家电话">
              <el-input v-model="editForm.StorePhone" placeholder="商家电话"></el-input>
            </el-form-item>
            <el-form-item label="商铺名称" style="margin-left: 20px">
              <el-input v-model="editForm.StoreName" placeholder="商铺名称"></el-input>
            </el-form-item>

            <el-form-item label="流水" style="margin-left: 20px">
              <el-button type="primary" size="mini" @click="getTopUpWaterList(editForm.LoginName)">流水</el-button>
            </el-form-item>
          </div>

          <el-form-item label="认证名称">
            <el-input v-model="editForm.Name" placeholder="认证名称"></el-input>
          </el-form-item>

          <div style="display: flex">
            <el-form-item label="省份">
              <el-input v-model="editForm.Province" placeholder="省份"></el-input>
            </el-form-item>
            <el-form-item label="城市">
              <el-input v-model="editForm.City" placeholder="城市"></el-input>
            </el-form-item>
            <el-form-item label="区域">
              <el-input v-model="editForm.Area" placeholder="区域"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="具体地址">
            <el-input v-model="editForm.StoreAddress" placeholder="具体地址"></el-input>
          </el-form-item>

          <el-form-item label="商铺类型">
            <el-radio v-model="editForm.StoreType" label="行情商">行情商</el-radio>
            <el-radio v-model="editForm.StoreType" label="酒商">酒商</el-radio>
            <el-radio v-model="editForm.StoreType" label="酒厂">酒厂</el-radio>
            <el-radio v-model="editForm.StoreType" label="茶商">茶商</el-radio>
            <el-radio v-model="editForm.StoreType" label="茶厂">茶厂</el-radio>
            <el-radio v-model="editForm.StoreType" label="其他">其他</el-radio>
          </el-form-item>

          <el-form-item label="商户描述">
            <el-input v-model="editForm.StoreBriefIntroduction" placeholder="商户描述"></el-input>
          </el-form-item>

          <div style="display: flex">
            <el-form-item label="经度">
              <el-input v-model="editForm.Longitude" placeholder="经度"></el-input>
            </el-form-item>
            <el-form-item label="纬度">
              <el-input v-model="editForm.Latitude" placeholder="纬度"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="头像">
            <el-upload
              ref="upload"
              action="https://api.chajiuqu.com/api/current/uploadimage"
              list-type="picture-card"
              :file-list="StoreHeadImage"
              :limit="1"
              :on-success="handleAvatarSuccess1"
              :on-remove="handleRemove1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="图片审核">
            <div class="auditImg">
              <div class="block" style="position: relative">
                <span>身份证正面</span>

                <el-image
                  v-if="editForm.StoreIDImage"
                  :src="editForm.StoreIDImage"
                  :preview-src-list="srcList"
                  alt
                ></el-image>
                <div v-else class="uploadImg" @click="uploadImg('StoreIDImage')">+</div>

                <div class="delBox" v-if="editForm.StoreIDImage" @click="delImg('StoreIDImage')">
                  <i class="el-icon-delete"></i>
                </div>
              </div>

              <div class="block" style="position: relative">
                <span>身份证反面</span>

                <el-image
                  v-if="editForm.StoreIDImage2"
                  :src="editForm.StoreIDImage2"
                  :preview-src-list="srcList"
                  alt
                ></el-image>
                <div v-else class="uploadImg" @click="uploadImg('StoreIDImage2')">+</div>

                <div class="delBox" v-if="editForm.StoreIDImage2" @click="delImg('StoreIDImage2')">
                  <i class="el-icon-delete"></i>
                </div>
              </div>

              <div class="block" style="position: relative">
                <span>营业执照</span>

                <el-image
                  v-if="editForm.StoreLicenseImage"
                  :src="editForm.StoreLicenseImage"
                  :preview-src-list="srcList"
                  alt
                ></el-image>
                <div v-else class="uploadImg" @click="uploadImg('StoreLicenseImage')">+</div>

                <div class="delBox" v-if="editForm.StoreLicenseImage" @click="delImg('StoreLicenseImage')">
                  <i class="el-icon-delete"></i>
                </div>
              </div>

              <div class="block" style="position: relative">
                <span>其他资质图片</span>

                <el-image
                  v-if="editForm.OtherDocuments"
                  :src="editForm.OtherDocuments"
                  :preview-src-list="srcList"
                  alt
                ></el-image>
                <div v-else class="uploadImg" @click="uploadImg('OtherDocuments')">+</div>

                <div class="delBox" v-if="editForm.OtherDocuments" @click="delImg('OtherDocuments')">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <!-- <div class="block">
                <span>商铺正面图片</span>
                <div v-if="!editForm.StoreBannerImage" style="text-align: center;">无上传</div>
                <el-image v-else :src="editForm.StoreBannerImage" :preview-src-list="srcList" alt=""></el-image>
              </div>-->
            </div>
          </el-form-item>

          <el-form-item label="审核状态">
            <!-- <el-input v-model="editForm.StoreAuditStatus" disabled></el-input> -->
            <el-radio v-model="editForm.StoreAuditStatus" :label="1">正在审核</el-radio>
            <el-radio v-model="editForm.StoreAuditStatus" :label="2">审核通过</el-radio>
            <el-radio v-model="editForm.StoreAuditStatus" :label="3">审核退回</el-radio>
          </el-form-item>
          <el-form-item label="审核内容">
            <el-input type="textarea" v-model="editForm.StoreAuditContent"></el-input>
          </el-form-item>
        </el-form>
      </template>

      <div style="min-height: 600px" v-else-if="activeName === '发布历史' && fabulist">
        <el-table
          ref="TableListRef1"
          class="TableList"
          border
          :data="fabulist"
          v-loading="loading"
          v-if="activeName === '发布历史'"
        >
          <el-table-column prop="Id" label="Id" align="center" v-if="activeName === '发布历史'"></el-table-column>

          <el-table-column prop="Title" label="发布内容" align="center" v-if="activeName === '发布历史'">
            <template slot-scope="scope">
              <div>
                {{ scope.row.Title && scope.row.Title.slice(0, 10) }}
                <span v-if="scope.row.Title && scope.row.Title.length > 10">...</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="IsRecommend"
            label="是否推荐/同省"
            align="center"
            v-if="activeName === '发布历史' && $store.state.user.info.Name !== 'user'"
          >
            <template slot-scope="scope">
              <template>
                <div v-if="scope.row.IsRecommend">推荐: {{ scope.row.IsRecommend ? '是' : '' }}</div>
                <div v-if="scope.row.IsProvince === 2">
                  {{ scope.row.Province }}: {{ scope.row.IsProvince === 2 ? '同省' : '' }}
                </div>
              </template>
            </template>
          </el-table-column>

          <el-table-column
            prop="IsProvince"
            label="同省申请"
            align="center"
            v-if="activeName === '发布历史' && $store.state.user.info.Name !== 'user'"
          >
            <template slot-scope="scope">
              <template>
                <span>{{ scope.row.IsProvince === 1 ? '申请(' + scope.row.Province + ')' : '' }}</span>
              </template>
            </template>
          </el-table-column>

          <el-table-column
            prop="Province"
            label="地区"
            align="center"
            v-if="activeName === '发布历史' && $store.state.user.info.Name === 'user'"
          ></el-table-column>

          <el-table-column prop="ReleaseTime" label="发布时间" align="center" v-if="activeName === '发布历史'">
            <template slot-scope="scope">
              <template>
                <span>{{ new Date(scope.row.ReleaseTime) | parseTime }}</span>
              </template>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" v-if="activeName === '发布历史'">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="onDetails(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="fenye1">
          <el-pagination
            class="TablePagination"
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="goodsPageindex"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="blistLength"
          ></el-pagination>
        </div>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '发布历史' && false">
        <ReleaseList :StoreName="editForm.StoreName"></ReleaseList>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '商品发布' && mblist">
        <el-table ref="TableListRef2" class="TableList" border :data="blist" v-loading="loading">
          <el-table-column prop="Category1" label="分类" align="center">
            <template slot-scope="scope">{{ scope.row.Category1 }}</template>
          </el-table-column>

          <el-table-column prop="Name" label="名称" align="center">
            <template slot-scope="scope">{{ scope.row.Name }}</template>
          </el-table-column>

          <el-table-column prop="InPrice" label="进货价" align="center">
            <template slot-scope="scope">{{ scope.row.InPrice }}</template>
          </el-table-column>

          <el-table-column prop="Price" label="零售价" align="center">
            <template slot-scope="scope">{{ scope.row.Price }}</template>
          </el-table-column>

          <el-table-column prop="Date" label="添加时间" align="center">
            <template slot-scope="scope">{{ new Date(scope.row.Date) | parseTime }}</template>
          </el-table-column>

          <el-table-column prop="Image" label="产品图片" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 40px; height: 40px"
                :src="scope.row.DetailImage.split(',')[0]"
                fit="contain"
                v-if="scope.row.DetailImage"
                :preview-src-list="[scope.row.DetailImage.split(',')[0]]"
              ></el-image>
              <el-image
                style="width: 40px; height: 40px"
                :src="scope.row.Image"
                fit="contain"
                :preview-src-list="[scope.row.Image]"
                v-else
              ></el-image>
            </template>
          </el-table-column>
        </el-table>

        <div class="fenye1">
          <!-- 分页 -->
          <el-pagination
            class="TablePagination"
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="goodsPageindex"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="blistLength"
          ></el-pagination>
        </div>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '商户产品库' && blist">
        <el-table ref="TableListRef2" class="TableList" border :data="blist" v-loading="loading">
          <el-table-column prop="Category1" label="分类" align="center">
            <template slot-scope="scope">{{ scope.row.Category1 }}</template>
          </el-table-column>

          <el-table-column prop="Name" label="名称" align="center">
            <template slot-scope="scope">{{ scope.row.Name }}</template>
          </el-table-column>

          <el-table-column prop="InPrice" label="进货价" align="center">
            <template slot-scope="scope">{{ scope.row.InPrice }}</template>
          </el-table-column>

          <el-table-column prop="Price" label="零售价" align="center">
            <template slot-scope="scope">{{ scope.row.Price }}</template>
          </el-table-column>

          <el-table-column prop="Date" label="添加时间" align="center">
            <template slot-scope="scope">{{ new Date(scope.row.Date) | parseTime }}</template>
          </el-table-column>

          <el-table-column prop="Image" label="产品图片" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 40px; height: 40px"
                :src="scope.row.DetailImage.split(',')[0]"
                fit="contain"
                v-if="scope.row.DetailImage"
                :preview-src-list="[scope.row.DetailImage.split(',')[0]]"
              ></el-image>
              <el-image
                style="width: 40px; height: 40px"
                :src="scope.row.Image"
                fit="contain"
                :preview-src-list="[scope.row.Image]"
                v-else
              ></el-image>
            </template>
          </el-table-column>
        </el-table>

        <div class="fenye1">
          <!-- 分页 -->
          <el-pagination
            class="TablePagination"
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="goodsPageindex"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="blistLength"
          ></el-pagination>
        </div>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '关注' && personalList && false">
        <el-table ref="TableListRef2" class="TableList" border :data="personalList" v-loading="loading">
          <el-table-column prop="LoginName" label="手机号码" align="center" v-if="activeName === '关注'">
            <template slot-scope="scope">{{ scope.row.LoginName }}</template>
          </el-table-column>

          <el-table-column prop="StoreName" label="商户名称" align="center" v-if="activeName === '关注'">
            <template slot-scope="scope">{{ scope.row.StoreName || '--' }}</template>
          </el-table-column>

          <el-table-column label="省市区" align="center" v-if="activeName === '关注'">
            <template slot-scope="scope">{{ scope.row.Province }}-{{ scope.row.City }}</template>
          </el-table-column>

          <el-table-column prop="VipTime" label="会员剩余时间" align="center" v-if="activeName === '关注'">
            <template slot-scope="scope">
              <template>
                <span v-if="ifOverdue(scope.row.VipTime)" style="color: #f00">已过期</span>
                <span v-else>{{ scope.row.VipTime | remainingDays }}天</span>
              </template>
              <!-- ({{ new Date(scope.row.VipTime) | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}) -->
            </template>
          </el-table-column>

          <el-table-column prop="CreateTime" label="创建时间" align="center" v-if="activeName === '关注'">
            <template slot-scope="scope">{{ new Date(scope.row.CreateTime) | parseTime }}</template>
          </el-table-column>
        </el-table>

        <div class="fenye1">
          <!-- 分页 -->
          <el-pagination
            class="TablePagination"
            background
            @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3"
            :current-page="personalPageindex"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="blistLength"
          ></el-pagination>
        </div>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '粉丝' && personalList && false">
        <el-table ref="TableListRef2" class="TableList" border :data="personalList" v-loading="loading">
          <el-table-column prop="LoginName" label="手机号码" align="center" v-if="activeName === '粉丝'">
            <template slot-scope="scope">{{ scope.row.LoginName }}</template>
          </el-table-column>

          <el-table-column prop="StoreName" label="商户名称" align="center" v-if="activeName === '粉丝'">
            <template slot-scope="scope">{{ scope.row.StoreName || '--' }}</template>
          </el-table-column>

          <el-table-column label="省市区" align="center" v-if="activeName === '粉丝'">
            <template slot-scope="scope">{{ scope.row.Province }}-{{ scope.row.City }}</template>
          </el-table-column>

          <el-table-column prop="VipTime" label="会员剩余时间" align="center" v-if="activeName === '粉丝'">
            <template slot-scope="scope">
              <template>
                <span v-if="ifOverdue(scope.row.VipTime)" style="color: #f00">已过期</span>
                <span v-else>{{ scope.row.VipTime | remainingDays }}天</span>
              </template>
              <!-- ({{ new Date(scope.row.VipTime) | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}) -->
            </template>
          </el-table-column>

          <el-table-column prop="CreateTime" label="创建时间" align="center" v-if="activeName === '粉丝'">
            <template slot-scope="scope">{{ new Date(scope.row.CreateTime) | parseTime }}</template>
          </el-table-column>
        </el-table>

        <div class="fenye1">
          <!-- 分页 -->
          <el-pagination
            class="TablePagination"
            background
            @size-change="handleSizeChange3"
            @current-change="handleCurrentChange3"
            :current-page="personalPageindex"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="blistLength"
          ></el-pagination>
        </div>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '留言' && false">
        <el-table ref="TableListRef2" class="TableList" border :data="editForm.SupportList" v-loading="loading">
          <el-table-column prop="Title" label="留言文章" align="center" v-if="activeName === '留言'">
            <template slot-scope="scope">{{ scope.row.Title ? scope.row.Title.slice(0, 30) : '--' }}</template>
          </el-table-column>

          <el-table-column prop="StoreName" label="留言商户" align="center" v-if="activeName === '留言'">
            <template slot-scope="scope">{{ scope.row.StoreName || '--' }}</template>
          </el-table-column>

          <el-table-column prop="SupportTitle" label="留言内容" align="center" v-if="activeName === '留言'">
            <template slot-scope="scope">{{ scope.row.SupportTitle || '--' }}</template>
          </el-table-column>

          <el-table-column prop="Date" label="留言时间" align="center" v-if="activeName === '留言'">
            <template slot-scope="scope">{{ new Date(scope.row.Date) | parseTime }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '关注'">
        <FocusAndFans :loading="loading" :UserId="editForm.Id"></FocusAndFans>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '粉丝'">
        <FocusAndFans :loading="loading" type="1" :UserId="editForm.Id"></FocusAndFans>
      </div>

      <div style="min-height: 600px" v-else-if="activeName === '留言'">
        <MessageList
          :merchantsInfo="editForm"
          type="1"
          :merchants="true"
          releaseType="1"
          :loading="loading"
        ></MessageList>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
        style="display: flex; align-items: center; justify-content: space-between"
      >
        <div>
          <el-button type="danger" @click="deleteVisible = true">删 除</el-button>
        </div>
        <div>
          <el-button @click="editPhoneDialog = false">取 消</el-button>
          <el-button type="warning" @click="editStoreDetermine()">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 发布管理 -->
    <el-dialog
      :visible.sync="releaseDialog"
      class="FormDialogBox"
      width="800px"
      title="发布管理"
      :close-on-click-modal="false"
      @close="releaseCancel()"
    >
      <el-form label-width="auto" :model="releaseForm" :rules="releaseRules" ref="ruleRelForm">
        <el-form-item label="Id">
          <el-input v-model="releaseForm.userId" placeholder="userId" disabled></el-input>
        </el-form-item>
        <!-- <el-form-item label="发布类型" prop="articleType">
          <el-input v-model="releaseForm.articleType" disabled></el-input>
          <el-radio v-model="releaseForm.articleType" label="出售">出售</el-radio>
          <el-radio v-model="releaseForm.articleType" label="收购">收购</el-radio>
        </el-form-item>-->
        <el-form-item label="发布内容" prop="title">
          <el-input type="textarea" v-model="releaseForm.title" placeholder="发布内容"></el-input>
        </el-form-item>
        <el-form-item label="发布图片">
          <el-upload
            ref="upload"
            action="https://api.chajiuqu.com/api/current/uploadimage"
            list-type="picture-card"
            :limit="6"
            :multiple="true"
            :on-preview="handlePictureCardPreview"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
            :on-change="handleChanges"
            :on-error="handleError"
            :auto-upload="false"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="releaseDialog = false">取 消</el-button>
        <el-button type="primary" @click="releaseDetermine()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="topUpDialog"
      class="FormDialogBox"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      @close="topUpDialogClose"
    >
      <div style="min-height: 500px">
        <ShowTableInfo
          ref="ShowTableInfoRef3"
          :underPagination="false"
          :showItem="showItem3"
          :getListFn="getListFn3"
          :param="topUpParam"
          :paramChangeGetList="true"
        >
          <template slot="CreateDate" slot-scope="scope">
            <span>{{ new Date(scope.data.CreateDate) | parseTime }}</span>
          </template>

          <template slot="GiveIntegral" slot-scope="scope" v-if="$store.state.user.info.Name === 'user'">
            <span v-if="scope.data.GiveIntegral === 68000">32000</span>
            <span v-else-if="scope.data.GiveIntegral === 168000">68000</span>
            <span v-else>{{ scope.data.GiveIntegral }}</span>
          </template>

          <template slot="Price" slot-scope="scope" v-if="$store.state.user.info.Name === 'user'">
            <span v-if="scope.data.Price === 680">320</span>
            <span v-else-if="scope.data.Price === 1680">680</span>
            <span v-else>{{ scope.data.Price }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="detailDialog"
      class="FormDialogBox"
      width="800px"
      title="详情"
      :close-on-click-modal="false"
      @close="detailDialog = false"
    >
      <el-form label-width="auto" :model="detailForm" ref="ruleForm">
        <div style="display: flex">
          <el-form-item label="发布时间">
            <span>{{ new Date(detailForm.ReleaseTime) | parseTime }}</span>
          </el-form-item>

          <el-form-item
            label="删除时间"
            style="margin-left: 20px"
            v-if="detailForm.Id === 6457 || detailForm.Id === 6369"
          >
            <span>2025-02-21</span>
          </el-form-item>
        </div>

        <el-form-item label="商铺类型">
          <span>{{ detailForm.StoreType }}</span>
        </el-form-item>

        <el-form-item label="浏览数">
          <span>{{ detailForm.BrowseCount }}</span>
        </el-form-item>

        <el-form-item label="发布内容">
          <el-input
            v-model="detailForm.Title"
            type="textarea"
            maxlength="1000"
            show-word-limit
            :autosize="{ minRows: 4, maxRows: 6 }"
            :disabled="true"
            placeholder="发布内容"
          ></el-input>
        </el-form-item>

        <el-form-item label="发布图片">
          <el-image
            v-for="(item, index) in myImage"
            :key="index"
            :src="item.url"
            style="width: 140px; height: 140px; margin-right: 10px"
            fit="contain"
          ></el-image>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailDetermine">确 认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%" center>
      <span style="display: block; width: 100%; text-align: center">是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteStoreDetermine(editForm)">确 定</el-button>
      </span>
    </el-dialog>

    <el-upload
      style="display: none"
      ref="upload2"
      action="https://api.chajiuqu.com/api/current/uploadimage"
      list-type="picture-card"
      :limit="1"
      :on-success="handleAvatarSuccess2"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
import provinceData from '@/utils/province.js'
import cityData from '@/utils/city.js'
import city1 from '@/utils/city1.js'

export default {
  name: 'membersIndex',
  components: {},
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      imageUrl: 0,
      imgArr: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      list: [],
      loading: true,
      LoginDate: [],
      beginDate: ['2024-02-21', '2025-02-21'],
      query: {
        pageindex: 1,
        pagesize: 1000,
        search: '',
        province: '',
        city: '',
        status: null,
        isSubmit: true,
        isStoreVip: null,
        certificationType: null
      },
      total: 0, // 总条数
      // 修改手机号
      editPhoneDialog: false,
      releaseDialog: false,
      editForm: {
        Phone: ''
      },
      rules: {
        Phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3|5|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'change' }
        ],
        VipTime: [{ required: true, message: '请选择会员日期', trigger: 'change' }],
        Level: [{ required: true, message: '请输入会员等级', trigger: 'blur' }],
        Integral: [{ required: true, message: '请输入积分', trigger: 'blur' }]
        // Province: [{ required: true, message: '请选择省市区', trigger: 'change' }]
      },
      releaseRules: {
        articleType: [{ required: true, message: '请选择发布类型', trigger: 'blur' }],
        title: [{ required: true, message: '请输入发布内容', trigger: 'blur' }]
      },
      // 省市区
      region: null,
      regionOptions: provinceData,
      regionOptions1: city1,
      regionOptions2: cityData,
      regionOptions3: city1,
      auditStatus: [
        {},
        {
          StoreAuditStatus: 1,
          type: '#409EFF',
          text: '正在审核'
        },
        {
          StoreAuditStatus: 2,
          type: '#67c23a',
          text: '审核通过'
        },
        {
          StoreAuditStatus: 3,
          type: '#f56c6c',
          text: '审核退回'
        }
      ],
      releaseForm: {
        userId: null,
        // articleType: null,
        // articleChannel: '自营',
        title: ''
      },

      checkBtnCurrent: 2,

      StoreHeadImage: [],

      activeName: '商户资料',
      blist: [],
      mblist: [],
      blistLength: 0,
      goodsPageindex: 1,

      fabulist: [],

      personalList: [],
      personalLength: [],
      personalPageindex: 1,

      deleteVisible: false,

      uploadImgKey: '',

      showItem3: [
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'GiveIntegral',
          label: '赠送积分'
        },
        {
          prop: 'Price',
          label: '价格'
        },
        {
          prop: 'CreateDate',
          label: '支付日期'
        },
        {
          prop: 'Remark',
          label: '备注'
        }
      ],
      topUpDialog: false,
      topUpParam: {
        pageindex: 1,
        pagesize: 20,
        search: '',
        status: 1
      },

      detailDialog: false,
      detailForm: {}
    }
  },
  computed: {
    Address: function () {
      return this.editForm.Province + this.editForm.City + this.editForm.Area
    },
    srcList: function () {
      return [
        this.editForm.StoreLicenseImage,
        this.editForm.StoreIDImage,
        this.editForm.StoreIDImage2,
        this.editForm.StoreBannerImage,
        this.editForm.OtherDocuments
      ]
    },

    myImage: function () {
      const arr = []
      if (this.detailForm.image) {
        this.detailForm.image.forEach((item, index) => {
          arr.push({
            url: item.Image,
            index: index
          })
        })
      }
      return arr
    }
  },
  async created() {
    this.getList('place', 2)
  },
  methods: {
    handlePictureCardPreview11(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleAvatarSuccess11(res, file, fileList) {
      // console.log(res)
      // console.log(fileList)
      this.imageUrl = fileList
      console.log(this.imageUrl)
    },
    handleRemove11(file, fileList) {
      this.imageUrl = fileList
      console.log(this.imageUrl)
      // console.log(file, fileList)
    },
    // 初始化
    init() {
      this.query.search = ''
      this.query.certificationType = null
      delete this.query.city
      delete this.query.province
      this.LoginDate = []
      this.beginDate = []
      // this.query.status = null
      this.regionOptions1 = this.regionOptions3

      this.getList('place')
    },

    getListFn3(query) {
      return this.$api.members.getTopUpWaterList(query)
    },

    getTopUpWaterList(search) {
      this.topUpParam = {
        ...this.topUpParam,
        search
      }

      this.topUpDialog = true
    },

    topUpDialogClose() {
      this.topUpDialog = false
    },

    async handleClick(tab) {
      console.log(this.activeName)
      if (this.activeName === '发布历史') {
        this.blist = []
        const { data: res } = await this.$api.release.articleList({
          pageindex: 1,
          name: this.editForm.StoreName,
          status: 2
        })
        console.log(res)
        this.fabulist = res.list
        this.blistLength = res.count
      } else if (this.activeName === '商户产品库') {
        this.fabulist = []
        const { data: res } = await this.$api.release.goodsList({
          category1: '',
          loginName: this.editForm.LoginName,
          pageindex: 1,
          pagesize: 10,
          type: 1
        })
        console.log('商户产品库', res)
        this.blist = res.list
        this.blistLength = res.count
      } else if (this.activeName === '商品发布') {
        this.fabulist = []
        const { data: res } = await this.$api.release.goodsList({
          category1: '',
          loginName: this.editForm.LoginName,
          pageindex: 1,
          pagesize: 10,
          type: 2,
          status: 1
        })
        console.log('商户产品库', res)
        this.blist = res.list
        this.blistLength = res.count
      } else if (this.activeName === '关注') {
        const { data } = await this.$api.release.getStoreSupportList({
          pageindex: 1,
          userId: this.editForm.Id
        })
        this.personalList = data.list
        this.personalLength = data.count
        console.log('商户关注', data)
      } else if (this.activeName === '粉丝') {
        const { data } = await this.$api.release.getStoreFansList({
          pageindex: 1,
          userId: this.editForm.Id
        })
        this.personalList = data.list
        this.personalLength = data.count
        console.log('商户关注', data)
      }
    },

    // 图片上传
    handleAvatarSuccess(res, file) {
      if (res.success) {
        if (!this.releaseForm.imgurls) {
          this.releaseForm.imgurls = res.data
        } else {
          this.releaseForm.imgurls += ',' + res.data
        }
      }
    },
    handleRemove(file, filelist) {
      // console.log(file, filelist)
      this.imageUrl = filelist.length
      this.imgArr = filelist
    },
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleChanges(file, fileList) {
      this.imageUrl = fileList.length
      this.imgArr = fileList
    },
    handleError(err, file, fileList) {
      console.log(err)
      this.$message.error(JSON.parse(err.message))
    },

    handleAvatarSuccess1(res, file, filelist) {
      // console.log(res, file, filelist)
      this.editForm.StoreHeadImage = res.data
    },
    handleRemove1(file, filelist) {
      console.log(file, filelist)
      this.editForm.StoreHeadImage = ''
      this.StoreHeadImage = []
    },

    uploadImg(key) {
      this.uploadImgKey = key
      console.log(key, this.$refs.upload2.$el.childNodes[1].click())
    },
    delImg(key) {
      this.editForm[key] = ''
    },
    handleAvatarSuccess2(res) {
      console.log(res.data)
      this.editForm[this.uploadImgKey] = res.data

      this.$nextTick(() => {
        this.uploadImgKey = ''
        this.$refs.upload2.clearFiles()
      })
    },
    handleRemove2(file, filelist) {
      console.log(file, filelist)
    },

    // 获取列表
    async getList(place, status) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        this.$nextTick(() => {
          this.$refs.TableListRef.bodyWrapper.scrollTop = 0
        })
      }

      if (this.query.city === '') delete this.query.city
      if (this.query.province === '') delete this.query.province
      // if (this.query.city || this.query.province) this.query.status = this.query.status

      if (status === 4) {
        this.query.isSubmit = true
        this.query.status = null
        this.query.sort = 'SubmitTime'
        this.checkBtnCurrent = status
      } else if (status) {
        delete this.query.isSubmit
        delete this.query.sort
        this.query.status = status - 0
        this.checkBtnCurrent = status
      }

      // if (this.query.isSubmit) {
      //   this.query.status = null
      // } else {
      //   delete this.query.isSubmit
      // }

      console.log('this.query', this.query)

      const user = this.$store.state.user.info
      // console.log('user', user)
      const api = user.Name === 'user' ? this.$api.members.getStoreList2 : this.$api.members.getStoreList
      const { data: res } = await api(this.query)
      console.log('获取商户审核列表', res)

      // res.list = res.list
      //   .filter((item) => {
      //     const t = new Date(item.StoreAuditTime).getTime()
      //     console.log(t, new Date('2024-02-21').getTime(), new Date('2025-02-21').getTime())
      //     return t > new Date('2024-02-21').getTime() && t < new Date('2025-02-21').getTime()
      //   })

      this.loading = false
      this.list = res.list
      this.total = res.count
    },
    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },

    // 状态改变
    async editStatus(item) {
      console.log('状态改变', item)

      try {
        const form = {
          listid: [item.Id],
          status: item.Status
        }
        await this.$api.members.editMembersStatus(form)
        this.$message.success('状态改变成功')
        this.getList()
      } catch (e) {
        this.getList()
      }
    },

    // 提交审核
    async auditStore(form) {
      const { data: res } = await this.$api.members.auditStore(form)
      console.log('审核结果', res)
    },

    // 发布信息
    release(item) {
      console.log('item', item)
      this.releaseForm.userId = item.Id
      this.releaseDialog = true
    },
    // 关闭发布对话框
    releaseCancel() {
      this.$refs.upload.clearFiles()
      this.imageUrl = 0
      this.releaseForm = {}
      // this.releaseForm.articleChannel = '自营'
    },
    // 发布对话框确定
    async releaseDetermine() {
      this.$refs.ruleRelForm.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在上传',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          if (this.imageUrl > 0) {
            console.log('111', this.imageUrl)
            await this.$refs.upload.submit()
          }

          setTimeout(async () => {
            if (this.releaseForm.imgurls) {
              console.log('this.releaseForm1', this.releaseForm)
              const { data: res } = await this.$api.release.articleAdd(this.releaseForm)
              console.log('上传结果', res)
            } else {
              console.log('this.releaseForm2', this.releaseForm)
              const { data: res } = await this.$api.release.articleAdd(this.releaseForm)
              console.log('上传结果', res)
            }

            // console.log('this.releaseForm', this.releaseForm)
            // loading.close()
            // const { data: res } = await this.$api.release.articleAdd(this.releaseForm)
            // console.log('上传结果', res)

            this.releaseForm = {}
            // this.releaseForm.articleChannel = '自营'

            loading.close()
            this.$message.success('添加成功')
            this.releaseDialog = false
            this.$refs.upload.clearFiles()
          }, 1000)
        } else {
          alert('请正确填写选择!')
          return false
        }
      })
    },

    // 下架商户发布
    async undercarriage(userId) {
      this.$confirm('是否下架该商户发布?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.article.updateStatus({
            userId,
            status: 0
          })
          this.$message({
            type: 'success',
            message: '下架成功!'
          })
        })
        .catch(() => {})
    },

    // 审核商户信息
    onEditInfo(item) {
      const form = this.$globalFun.deepClone(item)
      form.Phone = form.LoginName
      this.editForm = form

      if (!this.editForm.IsStore) this.editForm.Name = this.editForm.StoreName

      if (this.editForm.StoreHeadImage) {
        this.StoreHeadImage = [
          {
            url: this.editForm.StoreHeadImage
          }
        ]
      }
      console.log('this.editForm', this.editForm)
      this.editPhoneDialog = true
    },
    editPhoneCancel() {
      // console.log('对话框关闭')
      this.editForm = {}
      this.StoreHeadImage = []
      this.activeName = '商户资料'
    },

    async editPhoneDetermine() {
      if (this.editForm.StoreAuditStatus === 1) {
        this.$message.warning('请确定审核状态')
        return
      }

      const form = {}
      form.Id = this.editForm.Id
      form.StoreAuditStatus = this.editForm.StoreAuditStatus
      form.StoreAuditContent = this.editForm.StoreAuditContent
      console.log('111', form)

      const { data: res } = await this.$api.members.auditStore(form)
      console.log('审核结果', res)

      this.$message.success('修改成功')
      this.getList()
      this.editPhoneDialog = false
    },

    async deleteStoreDetermine(form) {
      console.log(form)
      if (!form) return

      // if (form.IsSubmit) {
      //   const data2 = await this.$api.members.editInfo({
      //     Id: form.Id,
      //     IsSubmit: false
      //   })
      //   console.log('修改', data2)
      // }

      // const data = await this.$api.members.deleteStore({
      //   phone: form.LoginName
      // })

      const { data } = await this.$api.members.editStore({
        Id: form.Id,
        IsStore: 0,
        IsSubmit: true,
        SubmitTime: true,
        CertificationType: ''
      })
      console.log('删除结果1', data)

      const { data2 } = await this.$api.members.auditStore({
        Id: form.Id,
        StoreAuditStatus: 0
      })
      console.log('删除结果2', data2)

      this.$message.success('删除成功')
      this.getList()
      this.editPhoneDialog = false
      this.deleteVisible = false
    },

    async editStoreDetermine() {
      console.log(this.editForm)
      const form = {}
      form.Id = this.editForm.Id
      form.StoreName = this.editForm.StoreName
      form.Name = this.editForm.Name
      form.StorePhone = this.editForm.StorePhone
      form.StoreHeadImage = this.editForm.StoreHeadImage
      form.Province = this.editForm.Province
      form.City = this.editForm.City
      form.Area = this.editForm.Area
      form.StoreAddress = this.editForm.StoreAddress
      form.StoreWx = this.editForm.StoreWx
      form.Longitude = this.editForm.Longitude - 0
      form.Latitude = this.editForm.Latitude - 0
      form.StoreType = this.editForm.StoreType
      form.CertificationType = this.editForm.CertificationType
      form.StoreBriefIntroduction = this.editForm.StoreBriefIntroduction
      form.StoreIDImage = this.editForm.StoreIDImage
      form.StoreIDImage2 = this.editForm.StoreIDImage2
      form.StoreLicenseImage = this.editForm.StoreLicenseImage
      form.OtherDocuments = this.editForm.OtherDocuments
      form.IsServer = true

      if (this.checkBtnCurrent !== 4) {
        form.IsSubmit = false
      }

      console.log('form', form)

      const { data: res1 } = await this.$api.members.editStore(form)
      console.log('提交结果', res1)

      const { data: res2 } = await this.$api.members.auditStore({
        Id: this.editForm.Id,
        StoreAuditStatus: this.editForm.StoreAuditStatus,
        StoreAuditContent: this.editForm.StoreAuditContent
      })
      console.log('审核结果', res2)

      if (
        !this.editForm.IsStore &&
        this.editForm.StoreAuditStatus === 2 &&
        this.editForm.CertificationType === '商户'
      ) {
        const { data: res1 } = await this.$api.release.articleAdd({
          userId: this.editForm.Id,
          title: '只要圈子足够大 一切皆有可能！我已完成认证，敬请多多留言交流哦！',
          imgurls:
            'https://cjq-1259532874.cosgz.myqcloud.com/ON96NKES0PQL.jpg,https://cjq-1259532874.cosgz.myqcloud.com/AIQD5RP5L9P3.jpg,https://cjq-1259532874.cosgz.myqcloud.com/HD0P3B2HX3YD.jpg'
        })
        const { data: res2 } = await this.$api.release.articleAudit({
          id: res1.Id,
          status: 2
        })
        await this.$api.release.articleRecommend({
          Id: res1.Id,
          IsRecommend: false,
          IsProvince: 2
        })
        console.log('发布结果', res2)
        window.location.hash = '#/businessManagement/release'
      } else if (!this.editForm.IsStore && this.editForm.StoreAuditStatus === 2) {
        const { data: res } = await this.$api.release.goodsSave({
          UserId: this.editForm.Id,
          Id: 0,
          Status: 1,
          Type: 2,
          Name: '只要圈子足够大 一切皆有可能！我已完成认证，敬请多多留言交流哦！',
          DetailImage:
            'https://cjq-1259532874.cosgz.myqcloud.com/ON96NKES0PQL.jpg,https://cjq-1259532874.cosgz.myqcloud.com/AIQD5RP5L9P3.jpg,https://cjq-1259532874.cosgz.myqcloud.com/HD0P3B2HX3YD.jpg',
          Category1: '首发'
        })
        console.log('发布结果', res)
        window.location.hash = '#/businessManagement/releaseGoods'
      }

      this.$message.success('修改成功')
      this.getList()
      this.editPhoneDialog = false
    },

    onDetails(item) {
      this.detailForm = { ...item }
      this.detailDialog = true
    },

    async detailDetermine() {
      this.detailDialog = false
    },

    // 地区选择
    handleChange1(e) {
      if (e) {
        this.query.province = this.regionOptions[e - 1].label
        this.regionOptions1 = this.regionOptions2[e - 1]
        this.query.city = null
        console.log('e', e, this.query.province)
      } else {
        this.query.province = null
        this.regionOptions1 = this.regionOptions3
      }
    },
    handleChange2(e) {
      console.log('e', e, this.query.city)
    },

    handleSizeChange1() {},

    async handleCurrentChange1(newPage) {
      this.goodsPageindex = newPage
      this.blist = []
      this.$nextTick(() => {
        this.$refs.TableListRe1.bodyWrapper.scrollTop = 0
      })
    },

    handleSizeChange2() {},

    async handleCurrentChange2(newPage) {
      this.goodsPageindex = newPage
      this.blist = []
      this.$nextTick(() => {
        this.$refs.TableListRef2.bodyWrapper.scrollTop = 0
      })

      const type = this.activeName === '商户产品库' ? 1 : 2
      const { data: res } = await this.$api.release.goodsList({
        category1: '',
        loginName: this.editForm.LoginName,
        pageindex: newPage,
        pagesize: 10,
        type
      })
      console.log('商户产品库', res)
      this.blist = res.list
      this.blistLength = res.count
    },

    handleSizeChange3() {},

    async handleCurrentChange3(newPage) {
      this.personalPageindex = newPage
      this.blist = []
      this.$nextTick(() => {
        this.$refs.TableListRef2.bodyWrapper.scrollTop = 0
      })

      let data = null
      if (this.activeName === '关注') {
        data = await this.$api.release.getStoreSupportList({
          pageindex: newPage,
          userId: this.editForm.Id
        })
      } else if (this.activeName === '粉丝') {
        data = await this.$api.release.getStoreFansList({
          pageindex: newPage,
          userId: this.editForm.Id
        })
      }
      this.personalList = data.list
      this.personalLength = data.count
      console.log('商户', data)
    },

    // 判断是否过期
    ifOverdue(time) {
      // console.log('time', time)
      const nowDate = new Date()
      const date = new Date(time).getTime() - nowDate.getTime()

      return date < 0
    }
  }
}
</script>

<style lang="scss" scoped>
// ::v-deep .FormDialogBox .el-dialog__body {
//   max-height: 80vh;
// }

.auditImg {
  display: flex;
  .block {
    margin-right: 25px;
    span {
      display: block;
      width: 120px;
      text-align: center;
    }
    img {
      width: 120px;
    }
  }
}

.uploadImg {
  width: 120px;
  height: 120px;

  border: 1px dashed #3a8ee6;

  font-size: 36px;
  color: #3a8ee6;

  display: flex;
  justify-content: center;
  align-items: center;
}

.delBox {
  position: absolute;
  top: 10px;
  right: 0;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  font-size: 18px;
}

.tabs {
  background-color: #fff;
  position: sticky;
  top: -30px;
  z-index: 9;
}

.TableList1 {
  min-height: 600px;
}
</style>
